import * as React from 'react';

const ArrowIcon: React.FC<React.SVGProps<SVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    className={props.className}
  >
    <g clipPath="url(#clip0_1014_4918)">
      <path
        className={props.className}
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="m9.5 7 5 5-5 5"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_1014_4918">
        <path fill="currentColor" className={props.className} d="M0 0h24v24H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default ArrowIcon;
